"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function PartnersSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="partners-section" className="w-full bg-[#f4f4f4] py-8 md:py-12">
      <div ref={ref} className={`page-container flex flex-col items-center justify-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-default text-2xl md:text-3xl font-bold text-foreground mb-3">
          Kooperationspartner
        </h2>
        <p className="text-muted-foreground text-sm md:text-base max-w-3xl mx-auto">Umzüge &amp; Entrümplung in Kooperation mit <a rel="noopener noreferrer" className="font-semibold text-foreground" data-ast-id="f:/src/pages/Services/sections/PartnersSection.tsx|sig:xol3sv" data-ast-start="856" data-ast-end="1025" href="https://umzuege-az.de/" target="_blank">https://umzuege-az.de/</a></p>
      </div>
    </section>;
}